import type { ReactNode } from 'react'
import { Select, type SelectOption } from './Select'

type TopHeaderSelectProps<T extends string | number> = {
  label: ReactNode
  value: T | null
  options: SelectOption<T>[]
  onChange: (value: T) => void
  ariaLabel: string
  disabled?: boolean
  searchable?: boolean
  emptyLabel?: string
  className?: string
}

export const TopHeaderSelect = <T extends string | number>({
  label,
  value,
  options,
  onChange,
  ariaLabel,
  disabled = false,
  searchable,
  emptyLabel,
  className,
}: TopHeaderSelectProps<T>) => (
  <Select<T>
    trigger="labeledPill"
    label={label}
    value={value}
    options={options}
    onChange={onChange}
    ariaLabel={ariaLabel}
    disabled={disabled}
    searchable={searchable}
    emptyLabel={emptyLabel}
    className={className}
  />
)
